<template>
    <v-container>
        <v-row>
            <v-col cols="12" v-if="producto">
                <v-dialog v-model="dialog" style="margin:0;" :width="$vuetify.breakpoint.name === 'xs' ? '100%' : '60%'" persistent>
                  <v-form ref="form" v-model="valido">
                    <v-card>
                        <v-card-title>
                          <v-container>
                              <v-row>
                                  <v-col cols="12" align="center" class="mt-5">
                                    <h2 v-if="getTipoMontaje === 'editar'" class="vietnam black--text display-2 mb-5 pb-5">{{ $t('Formularios.EditarProducto') }}</h2>
                                    <h2 v-else class="vietnam black--text display-2 mb-5 pb-5">{{ $t('Formularios.NuevoProducto') }}</h2>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-text-field solo v-model="producto.titulo" :label="$t('Formularios.Titulo')" :hint="$t('Formularios.Titulo')" :rules="requerido" persistent-hint/>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-text-field solo v-model="producto.referencia" :label="$t('Formularios.Referencia')" :hint="$t('Formularios.Referencia')" :rules="requerido" persistent-hint/>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="4" v-if="!producto.exponer">
                                    <v-switch solo v-model="producto.fisico" :label="$t('Formularios.Fisico')" color="error" style="word-break:break-word;"/>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="4" v-if="!producto.exponer">
                                    <v-switch solo v-model="producto.digital" :label="$t('Formularios.Digital')" color="error" style="word-break:break-word;"/>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="4">
                                    <v-switch solo v-model="producto.exponer" :label="$t('Formularios.Exponer')" color="error" style="word-break:break-word;"/>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-textarea solo v-model="producto.descripcion" :label="$t('Formularios.DescripcionEs')" :hint="$t('Formularios.DescripcionEs')" :rules="requerido" persistent-hint/>
                                  </v-col>
                                  <!-- DESCRIPCION EN INGLES -->
                                  <v-col cols="12">
                                    <v-textarea solo v-model="producto.descripcionEn" :label="$t('Formularios.DescripcionEn')" :hint="$t('Formularios.DescripcionEn')" :rules="requerido" persistent-hint/>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-select solo persistent-hint v-model="marca" :items="marcasDeAgua" item-text="titulo" item-value="id" :label="$t('Formularios.MarcaDeAgua')" :hint="$t('Formularios.MarcaDeAgua')" />
                                  </v-col>
                                  <v-col cols="12">
                                    <v-file-input solo v-model="preImagenPrincipal" :label="$t('Formularios.ImagenPrincipal')" :hint="$t('Formularios.ImagenPrincipal')" accept="image/*" :rules="getTipoMontaje === 'editar' ? [] : requerido" persistent-hint/>
                                  </v-col>
                                  <v-col cols="12" align="center">
                                      <v-file-input solo v-model="preImagenes" :label="$t('Formularios.ImagenesApoyo')" :hint="$t('Formularios.ImagenesApoyo')"  multiple accept="image/*" counter="2" persistent-hint/>
                                      <span v-if="preImagenes.length > 2">{{$t('Formularios.AdvertenciaImagenes')}}</span>
                                  </v-col>
                                  <v-col cols="12" v-if="getTipoMontaje === 'editar'">
                                    <v-row>
                                      <v-col cols="12" xs="12" sm="6" md="4" v-for="(i, index) in producto.imagenes" :key="i" align="center">
                                        <v-img :src="i"></v-img>
                                        <v-btn color="primary" @click="eliminarImagen(index)">{{$t('Formularios.Eliminar')}}</v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-text-field solo v-model="producto.video" :label="$t('Formularios.Video')" :hint="$t('Formularios.Video')" persistent-hint/>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-select v-model="producto.plataforma" :items="plataformas" solo :label="$t('Formularios.Plataforma')" :hint="$t('Formularios.Plataforma')" persistent-hint/>
                                  </v-col>
                                  <v-col cols="12">
                                      <v-autocomplete solo :items="subcategorias" v-model="producto.subcategoria" item-text="titulo" item-value="id" :label="$t('Formularios.Categoria')" :hint="$t('Formularios.Categoria')" :rules="requerido" persistent-hint/> <!-- :rules="[$t('Formularios.CategoriaRequerido')]" -->
                                  </v-col>
                                  <v-col cols="12" v-if="getUsuario.categoria === 'artista'">
                                    <v-autocomplete solo :items="estilos" v-model="producto.estilo" item-text="titulo" item-value="id" :label="$t('Formularios.Estilo')" :hint="$t('Formularios.Estilo')" persistent-hint/>
                                  </v-col>
                                  <!-- <v-col cols="12" v-if="getUsuario.categoria === 'artista'">
                                    <v-autocomplete solo :items="colores" v-model="producto.color" item-text="titulo" item-value="id" :label="$t('Formularios.Color')" :hint="$t('Formularios.Color')" />
                                  </v-col> -->
                                  <v-col cols="12" v-if="getUsuario.categoria === 'artista'">
                                    <v-autocomplete solo :items="orientaciones" v-model="producto.orientacion" item-text="titulo" item-value="id" :label="$t('Formularios.Orientacion')" :hint="$t('Formularios.Orientacion')" persistent-hint/>
                                  </v-col>
                                  <v-col cols="12" v-if="getUsuario.categoria === 'artista'">
                                    <v-text-field solo v-model="producto.tecnica" :label="$t('Formularios.TecnicaEs')" :hint="$t('Formularios.TecnicaEs')" persistent-hint/>
                                  </v-col>
                                  <!-- TECNICA EN INGLES -->
                                   <v-col cols="12" v-if="getUsuario.categoria === 'artista'">
                                    <v-text-field solo v-model="producto.tecnicaEn" :label="$t('Formularios.TecnicaEn')" :hint="$t('Formularios.TecnicaEn')" persistent-hint/>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-textarea solo v-model="producto.materiales" :label="$t('Formularios.MaterialesEs')" :hint="$t('Formularios.MaterialesEs')" :rules="requerido" persistent-hint/>
                                  </v-col>
                                  <!-- MATERIALES EN INGLES -->
                                  <v-col cols="12">
                                    <v-textarea solo v-model="producto.materialesEn" :label="$t('Formularios.MaterialesEn')" :hint="$t('Formularios.MaterialesEn')" :rules="requerido" persistent-hint/>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-textarea solo v-model="producto.cuidados" :label="$t('Formularios.CuidadosEs')" :hint="$t('Formularios.CuidadosEs')" :rules="requerido" persistent-hint/>
                                  </v-col>
                                  <!-- CUIDADOS EN INGLES -->
                                  <v-col cols="12">
                                    <v-textarea solo v-model="producto.cuidadosEn" :label="$t('Formularios.CuidadosEn')" :hint="$t('Formularios.CuidadosEn')" :rules="requerido" persistent-hint/>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-combobox v-model="producto.etiquetas" :label="$t('Formularios.Etiquetas')" :hint="$t('Formularios.Etiquetas')" persistent-hint solo multiple chips deletable-chips append-icon />
                                  </v-col>
                                  <v-col cols="12" v-if="!producto.exponer && (producto.fisico || producto.digital)">
                                    <v-row>
                                      <v-col cols="12" align="center" v-if="getUsuario.pais === 48">
                                        <h3 style="word-break:break-word;">{{$t('Formularios.SeleccionaTipoMoneda')}}</h3>
                                      </v-col>
                                      <!-- CASILLA PRECIO EN PESOS COL CHECKBOX -->
                                      <div :style="check_div_style" class="ml-4 mr-4">
                                        <v-checkbox solo v-model="producto.precioCOL" :label="$t('Formularios.PrecioCOL')" color="error" @change="precioCol()" v-if="getUsuario.pais === 48" />
                                        <v-checkbox solo v-model="producto.precioUSD" :label="$t('Formularios.PrecioUSD')" color="error" @change="precioUsd()" v-if="getUsuario.pais === 48" />
                                      </div>
                                      <div v-if="producto.precioCOL || producto.precioUSD" :style="check_div_style">
                                        <v-col cols="6" xs="6" md="6" class="ml-1">
                                          <v-checkbox solo v-model="producto.encargo" :label="$t('Formularios.Encargo')" color="error"/>
                                        </v-col>
                                        <v-col cols="6" xs="6" md="6" v-if="producto.encargo" >
                                          <v-currency-field :rules="requeridoNumber" solo v-model="producto.encargoDias" :label="$t('Formularios.EncargoDias')" :hint="$t('Formularios.EncargoDias')" persistent-hint type="number" />
                                        </v-col>
                                      </div>
                                       <!-- CASILLA PRECIO EN USD CHECKBOX -->
                                      <v-col cols="12" align="center" v-if="checkUSD">
                                        <em><b><p style="word-break:break-word;">{{$t('Formularios.PrecioDiaVenta')}}</p></b></em>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="12" v-if="producto.fisico && !producto.exponer">
                                    <v-divider />
                                    <v-row>
                                      <v-col cols="12" align="center">
                                        <h2>{{ $t('Formularios.ZonaFisico')}}</h2>
                                      </v-col>
                                      <!-- CASILLA PRODUCTO FACTURA IVA -->
                                      <v-checkbox class="ml-4" style="justify-content: center;" v-model="producto.iva" :label="$t('Formularios.MiProductoIVA')"></v-checkbox>

                                      <v-col cols="8"></v-col>
                                      <v-col cols="12" xs="12" md="4">
                                        <v-currency-field :rules="requeridoNumber" solo v-model="producto.precioFisico" :label="$t('Formularios.ValorNeto')" :hint="$t('Formularios.ValorNeto')" persistent-hint type="text" v-if="producto.fisico && getUsuario.pais === 48 && producto.precioCOL" required/>
                                        <v-currency-field :rules="requerido" solo v-model="producto.precioFisicoUSD" :label="$t('Formularios.ValorNetoUSD')" :hint="$t('Formularios.ValorNetoUSD')" persistent-hint type="number" v-if="producto.fisico && getUsuario.pais != 48" required/>
                                        <v-currency-field :rules="requerido" solo v-model="producto.precioFisicoUSD" :label="$t('Formularios.ValorNetoUSD')" :hint="$t('Formularios.ValorNetoUSD')" persistent-hint type="number" v-if="producto.precioUSD" required/>
                                      </v-col>
                                      <v-col cols="12" xs="12" md="4">
                                        <v-currency-field solo v-model="comisionTrArtistFisico" readonly :label="$t('Formularios.ComisionTrArtist')" :hint="$t('Formularios.ComisionTrArtist')" persistent-hint type="number" v-if="producto.fisico && getUsuario.pais === 48 && producto.precioCOL"/>
                                        <v-currency-field solo v-model="comisionTrArtistFisicoUSD" readonly :label="$t('Formularios.ComisionTrArtistUSD')" :hint="$t('Formularios.ComisionTrArtistUSD')" persistent-hint type="number" v-if="producto.fisico && getUsuario.pais != 48"/>
                                        <v-currency-field solo v-model="comisionTrArtistFisicoUSD" readonly :label="$t('Formularios.ComisionTrArtistUSD')" :hint="$t('Formularios.ComisionTrArtistUSD')" persistent-hint type="number" v-if="producto.precioUSD"/>
                                      </v-col>
                                      <v-col cols="12" xs="12" md="4">
                                        <v-currency-field solo v-model="ivaNetoFisico" readonly :label="$t('Formularios.IvaNeto')" :hint="$t('Formularios.IvaNeto')" persistent-hint type="number" v-if="producto.fisico && getUsuario.pais === 48 && producto.precioCOL"/>
                                        <v-currency-field solo v-model="ivaNetoFisicoUSD" readonly :label="$t('Formularios.IvaNetoUSD')" :hint="$t('Formularios.IvaNetoUSD')" persistent-hint type="number" v-if="producto.fisico && getUsuario.pais != 48"/>
                                        <v-currency-field solo v-model="ivaNetoFisicoUSD" readonly :label="$t('Formularios.IvaNetoUSD')" :hint="$t('Formularios.IvaNetoUSD')" persistent-hint type="number" v-if="producto.precioUSD"/>
                                      </v-col>
                                      <v-col cols="12" xs="12" md="4">
                                        <v-currency-field solo v-model="precioSinIVAFisico" readonly :label="$t('Formularios.PrecioSinIva')" :hint="$t('Formularios.PrecioSinIva')" persistent-hint type="number" v-if="producto.fisico && getUsuario.pais === 48 && producto.precioCOL"/>
                                        <v-currency-field solo v-model="precioSinIVAFisicoUSD" readonly :label="$t('Formularios.PrecioSinIvaUSD')" :hint="$t('Formularios.PrecioSinIvaUSD')" persistent-hint type="number" v-if="producto.fisico && getUsuario.pais != 48"/>
                                        <v-currency-field solo v-model="precioSinIVAFisicoUSD" readonly :label="$t('Formularios.PrecioSinIvaUSD')" :hint="$t('Formularios.PrecioSinIvaUSD')" persistent-hint type="number" v-if="producto.precioUSD"/>
                                      </v-col>
                                      <!-- PRECIO FINAL PUBLICO EN PESOS COLOMBIANOS -->
                                      <v-col cols="12" xs="12" md="4">
                                        <v-currency-field v-if="producto.fisico & getUsuario.pais === 48 & producto.precioCOL"  solo v-model="precioFinalFisicoCOP" readonly :label="$t('Formularios.PrecioPublicoCOL')" :hint="$t('Formularios.PrecioPublicoCOL')" persistent-hint/>
                                        <v-currency-field v-if="producto.fisico & getUsuario.pais != 48"  solo v-model="precioFinalFisicoUSD" readonly :label="$t('Formularios.PrecioPublicoUSD')" :hint="$t('Formularios.PrecioPublicoUSD')" persistent-hint/>
                                        <v-currency-field v-if="producto.precioUSD"  solo v-model="precioFinalFisicoUSD" readonly :label="$t('Formularios.PrecioPublicoUSD')" :hint="$t('Formularios.PrecioPublicoUSD')" persistent-hint/>
                                      </v-col>
                                      <v-col cols="12" xs="12" md="4">
                                        <v-currency-field solo v-model="vendedorRecibiraFisico" readonly :label="$t('Formularios.VendedorRecibira')" :hint="$t('Formularios.VendedorRecibira')" persistent-hint type="number" v-if="producto.fisico & getUsuario.pais === 48 & producto.precioCOL"/>
                                        <v-currency-field solo v-model="vendedorRecibiraFisicoUSD" readonly :label="$t('Formularios.VendedorRecibiraUSD')" :hint="$t('Formularios.VendedorRecibiraUSD')" persistent-hint type="number" v-if="producto.fisico & getUsuario.pais != 48"/>
                                        <v-currency-field solo v-model="vendedorRecibiraFisicoUSD" readonly :label="$t('Formularios.VendedorRecibiraUSD')" :hint="$t('Formularios.VendedorRecibiraUSD')" persistent-hint type="number" v-if="producto.precioUSD"/>
                                      </v-col>
                                      <v-col cols="12" xs="12" md="4">
                                        <v-currency-field solo v-model="ivaNetoFisico" readonly :label="$t('Formularios.IvaVendedor')" :hint="$t('Formularios.IvaVendedor')" persistent-hint type="number" v-if="producto.fisico & getUsuario.pais === 48 & producto.precioCOL"/>
                                        <v-currency-field solo v-model="ivaNetoFisicoUSD" readonly :label="$t('Formularios.IvaVendedorUSD')" :hint="$t('Formularios.IvaVendedorUSD')" persistent-hint type="number" v-if="producto.fisico & getUsuario.pais != 48"/>
                                        <v-currency-field solo v-model="ivaNetoFisicoUSD" readonly :label="$t('Formularios.IvaVendedorUSD')" :hint="$t('Formularios.IvaVendedorUSD')" persistent-hint type="number" v-if="producto.precioUSD"/>
                                      </v-col>
                                      <!-- <v-col cols="4" xs="12" md="4">
                                        <v-text-field solo v-model="precioFinalFisicoUSD" readonly :label="$t('Formularios.PrecioFinalUSD')" :hint="$t('Formularios.PrecioFinalUSD')" persistent-hint/>
                                      </v-col> -->
                                      <v-col cols="12" xs="12" md="12">
                                        <v-currency-field solo v-model="producto.descuentoFisico" type="number" :max="100" :min="0" :label="$t('Carrito.Descuento')" :hint="$t('Carrito.Descuento')" persistent-hint />
                                      </v-col>
                                       <!-- CASILLA ENVIO MISMO PAIS -->
                                       <v-col cols="12" xs="12" md="6">
                                        <v-currency-field solo v-model="producto.costeEnvio" type="number" :disabled="checkEnvio" :label="$t('Carrito.PrecioEnvioNacional')" :hint="$t('Carrito.PrecioEnvioNacional')" persistent-hint />
                                      </v-col>
                                      <!-- CASILLA ENVIO INCLUIDO CHECKBOX -->
                                      <div class="ml-6 mt-1">
                                        <v-checkbox solo v-model="producto.envioIncluido" :label="$t('Formularios.EnvioIncluido')" color="error" @change="validarEnvioNacional()" />
                                      </div>
                                      <!-- COLOR TALLA -->
                                      <v-col cols="12" align="center" v-if="!producto.color && !producto.talla">
                                        <p style="word-break:break-word;">{{$t('Formularios.SeleccionaColor')}}</p>
                                      </v-col>
                                      <div :style="check_div_style_ct" class="ml-4">
                                        <v-checkbox solo v-model="producto.color" :label="$t('Formularios.Color')" color="error" @change="limpiarInventario()" />
                                        <v-checkbox solo v-model="producto.talla" :label="$t('Formularios.Talla')" color="error" @change="limpiarInventario()" />
                                      </div>
                                      <v-col cols="12" align="center" v-if="producto.talla || producto.color">
                                        <p style="word-break:break-word;">{{$t('Formularios.AgregaColor')}}</p>
                                      </v-col>
                                      <v-col cols="12" v-if="producto.color">
                                          <v-data-table
                                          :items="producto.colores"
                                          :headers="headerColores">
                                          <template v-slot:top>
                                              <v-toolbar flat>
                                                  <v-toolbar-title>{{$t('Oficina.Colores')}}</v-toolbar-title>
                                                  <v-divider class="mx-4" inset vertical />
                                                  <v-spacer />
                                                  <v-btn color="primary" outlined style="border: 2px solid" @click="color({tipo: 'nuevo'})">{{$t('Oficina.NuevoColor')}}</v-btn>
                                              </v-toolbar>
                                          </template>
                                          <template v-slot:[`item.color`]="{ item }">
                                            <v-avatar :color="item.color.hex" max-height="90%"></v-avatar>
                                          </template>
                                          <template v-slot:[`item.acciones`]="{ item }">
                                            <v-icon small class="mr-2" @click="color({tipo: 'editar', valor: item})">fas fa-edit</v-icon>
                                            <v-icon small @click="color({tipo: 'eliminar', valor: item})">fas fa-trash</v-icon>
                                          </template>
                                          </v-data-table>
                                      </v-col>
                                      <v-col cols="12" v-if="producto.talla">
                                          <v-data-table
                                          :items="producto.tallas"
                                          :headers="headerTallas">
                                          <template v-slot:top>
                                              <v-toolbar flat>
                                                  <v-toolbar-title>{{$t('Oficina.Tallas')}}</v-toolbar-title>
                                                  <v-divider class="mx-4" inset vertical />
                                                  <v-spacer />
                                                  <v-btn color="primary" outlined style="border: 2px solid" @click="talla({tipo: 'nuevo'})">{{$t('Oficina.NuevaTalla')}}</v-btn>
                                              </v-toolbar>
                                          </template>
                                          <template v-slot:body="{ items }">
                                            <tbody>
                                              <tr v-for="i in items" :key="i">
                                                <td align="center">{{i}}</td>
                                                <td align="center">
                                                  <v-icon small class="mr-2" @click="talla({tipo: 'editar', valor: item})">fas fa-edit</v-icon>
                                                  <v-icon small @click="talla({tipo: 'eliminar', valor: item})">fas fa-trash</v-icon>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </template>
                                          <!-- <template v-slot:item.talla="{ item }">
                                            <span>{{ item }}</span>
                                          </template>
                                          <template v-slot:item.acciones="{ item }">
                                            <v-icon small class="mr-2" @click="talla({tipo: 'editar', valor: item})">fas fa-edit</v-icon>
                                            <v-icon small @click="talla({tipo: 'eliminar', valor: item})">fas fa-trash</v-icon>
                                          </template> -->
                                          </v-data-table>
                                      </v-col>
                                      <v-col cols="12">
                                          <v-data-table
                                          :items="producto.inventario"
                                          :headers="headerInventario">
                                          <template v-slot:top>
                                              <v-toolbar flat>
                                                  <v-toolbar-title>{{$t('Oficina.Inventario')}}</v-toolbar-title>
                                                  <v-divider class="mx-4" inset vertical />
                                                  <v-spacer />
                                                  <v-btn color="primary" outlined style="border: 2px solid" @click="inventario({tipo: 'nuevo'})">{{$t('Oficina.NuevaVariacion')}}</v-btn>
                                              </v-toolbar>
                                          </template>
                                          <template v-slot:[`item.color`]="{ item }">
                                            <v-avatar v-if="producto.color" :color="item.color.color.hex" max-height="90%"></v-avatar>
                                          </template>
                                          <template v-slot:[`item.tituloColor`]="{ item }">
                                            <span v-if="producto.color">{{ item.color.tituloColor }}</span>
                                          </template>
                                          <template v-slot:[`item.talla`]="{ item }">
                                            <span v-if="producto.talla">{{ item.talla }}</span>
                                          </template>
                                          <template v-slot:[`item.acciones`]="{ item }">
                                            <v-icon small class="mr-2" @click="inventario({tipo: 'editar', valor: item})">fas fa-edit</v-icon>
                                            <v-icon small @click="inventario({tipo: 'eliminar', valor: item})">fas fa-trash</v-icon>
                                          </template>
                                          </v-data-table>
                                      </v-col>
                                      <v-col cols="12">
                                        <v-text-field solo v-model="producto.cantidadFisico" readonly :label="$t('Oficina.InventarioTotal')" :hint="$t('Oficina.InventarioTotal')" persistent-hint type="number" />
                                      </v-col>
                                      <v-divider />
                                    </v-row>
                                  </v-col>
                                  <v-col cols="12" v-if="producto.talla">
                                    <v-file-input solo v-model="preTablaDeTallas" :label="$t('Formularios.TablaTallas')" :hint="$t('Formularios.TablaTallas')" />
                                  </v-col>
                                  <v-col cols="12" v-if="producto.digital && !producto.exponer">
                                    <v-divider />
                                    <v-row>
                                      <v-col cols="12" align="center">
                                        <h2>{{ $t('Formularios.ZonaDigital')}}</h2>
                                      </v-col>
                                      <v-col cols="12">
                                        <v-checkbox v-model="producto.ivaDigital" label="Mi producto factura IVA"></v-checkbox>
                                      </v-col>

                                      <v-col cols="12" xs="12" md="4">
                                        <v-currency-field :rules="requerido" solo v-model="producto.precioDigital" :label="$t('Formularios.ValorNeto')" :hint="$t('Formularios.ValorNeto')" persistent-hint type="number" v-if="producto.digital & getUsuario.pais === 48 & producto.precioCOL" />
                                        <v-currency-field :rules="requerido" solo v-model="producto.precioDigitalUSD" :label="$t('Formularios.ValorNetoUSD')" :hint="$t('Formularios.ValorNetoUSD')" persistent-hint type="number" v-if="producto.digital & getUsuario.pais != 48"/>
                                        <v-currency-field :rules="requerido" solo v-model="producto.precioDigitalUSD" :label="$t('Formularios.ValorNetoUSD')" :hint="$t('Formularios.ValorNetoUSD')" persistent-hint type="number" v-if="producto.precioUSD"/>
                                      </v-col>
                                      <v-col cols="12" xs="12" md="4">
                                        <v-currency-field solo v-model="comisionTrArtistDigital" readonly :label="$t('Formularios.ComisionTrArtist')" :hint="$t('Formularios.ComisionTrArtist')" persistent-hint type="number" v-if="producto.digital & getUsuario.pais === 48 & producto.precioCOL"/>
                                        <v-currency-field solo v-model="comisionTrArtistDigitalUSD" readonly :label="$t('Formularios.ComisionTrArtistUSD')" :hint="$t('Formularios.ComisionTrArtistUSD')" persistent-hint type="number" v-if="producto.digital & getUsuario.pais != 48"/>
                                        <v-currency-field solo v-model="comisionTrArtistDigitalUSD" readonly :label="$t('Formularios.ComisionTrArtistUSD')" :hint="$t('Formularios.ComisionTrArtistUSD')" persistent-hint type="number" v-if="producto.precioUSD"/>
                                      </v-col>
                                      <v-col cols="12" xs="12" md="4">
                                        <v-currency-field solo v-model="ivaNetoDigital" readonly :label="$t('Formularios.IvaNeto')" :hint="$t('Formularios.IvaNeto')" persistent-hint type="number" v-if="producto.digital & getUsuario.pais === 48 & producto.precioCOL"/>
                                        <v-currency-field solo v-model="ivaNetoDigitalUSD" readonly :label="$t('Formularios.IvaNetoUSD')" :hint="$t('Formularios.IvaNetoUSD')" persistent-hint type="number" v-if="producto.digital & getUsuario.pais != 48"/>
                                        <v-currency-field solo v-model="ivaNetoDigitalUSD" readonly :label="$t('Formularios.IvaNetoUSD')" :hint="$t('Formularios.IvaNetoUSD')" persistent-hint type="number" v-if="producto.precioUSD"/>
                                      </v-col>
                                      <v-col cols="12" xs="12" md="4">
                                        <v-currency-field solo v-model="precioSinIVADigital" readonly :label="$t('Formularios.PrecioSinIva')" :hint="$t('Formularios.PrecioSinIva')" persistent-hint type="number" v-if="producto.digital & getUsuario.pais === 48 & producto.precioCOL"/>
                                        <v-currency-field solo v-model="precioSinIVADigitalUSD" readonly :label="$t('Formularios.PrecioSinIvaUSD')" :hint="$t('Formularios.PrecioSinIvaUSD')" persistent-hint type="number" v-if="producto.digital & getUsuario.pais != 48"/>
                                        <v-currency-field solo v-model="precioSinIVADigitalUSD" readonly :label="$t('Formularios.PrecioSinIvaUSD')" :hint="$t('Formularios.PrecioSinIvaUSD')" persistent-hint type="number" v-if="producto.precioUSD"/>
                                      </v-col>
                                      <!-- PRECIO FINAL PUBLICO EN PESOS COLOMBIANOS -->
                                      <v-col cols="12" xs="12" md="4">
                                        <v-currency-field v-if="producto.digital & getUsuario.pais === 48 & producto.precioCOL"  solo v-model="precioFinalDigitalCOP" readonly :label="$t('Formularios.PrecioPublicoCOL')" :hint="$t('Formularios.PrecioPublicoCOL')" persistent-hint/>
                                        <v-currency-field v-if="producto.digital & getUsuario.pais != 48"  solo v-model="precioFinalDigitalUSD" readonly :label="$t('Formularios.PrecioPublicoUSD')" :hint="$t('Formularios.PrecioPublicoUSD')" persistent-hint/>
                                        <v-currency-field v-if="producto.precioUSD"  solo v-model="precioFinalDigitalUSD" readonly :label="$t('Formularios.PrecioPublicoUSD')" :hint="$t('Formularios.PrecioPublicoUSD')" persistent-hint/>
                                      </v-col>
                                      <v-col cols="12" xs="12" md="4">
                                        <v-currency-field solo v-model="vendedorRecibiraDigital" readonly :label="$t('Formularios.VendedorRecibira')" :hint="$t('Formularios.VendedorRecibira')" persistent-hint type="number" v-if="producto.digital & getUsuario.pais === 48 & producto.precioCOL"/>
                                        <v-currency-field solo v-model="vendedorRecibiraDigitalUSD" readonly :label="$t('Formularios.VendedorRecibiraUSD')" :hint="$t('Formularios.VendedorRecibiraUSD')" persistent-hint type="number" v-if="producto.digital & getUsuario.pais != 48"/>
                                        <v-currency-field solo v-model="vendedorRecibiraDigitalUSD" readonly :label="$t('Formularios.VendedorRecibiraUSD')" :hint="$t('Formularios.VendedorRecibiraUSD')" persistent-hint type="number" v-if="producto.precioUSD"/>
                                      </v-col>
                                      <v-col cols="12" xs="12" md="4">
                                        <v-currency-field solo v-model="ivaNetoDigital" readonly :label="$t('Formularios.IvaVendedor')" :hint="$t('Formularios.IvaVendedor')" persistent-hint type="number" v-if="producto.digital & getUsuario.pais === 48 & producto.precioCOL"/>
                                        <v-currency-field solo v-model="ivaNetoDigitalUSD" readonly :label="$t('Formularios.IvaVendedorUSD')" :hint="$t('Formularios.IvaVendedorUSD')" persistent-hint type="number" v-if="producto.digital & getUsuario.pais != 48"/>
                                        <v-currency-field solo v-model="ivaNetoDigitalUSD" readonly :label="$t('Formularios.IvaVendedorUSD')" :hint="$t('Formularios.IvaVendedorUSD')" persistent-hint type="number" v-if="producto.precioUSD"/>
                                      </v-col>
                                      <v-col cols="12" xs="12" md="12">
                                        <v-currency-field solo v-model="producto.descuentoDigital" type="number" :max="100" :min="0" :label="$t('Carrito.Descuento')" :hint="$t('Carrito.Descuento')" persistent-hint />
                                      </v-col>
                                      <v-col cols="8">
                                        <v-text-field solo v-model="producto.cantidadDigital" persistent-hint :label="$t('Formularios.CantidadDigital')" :hint="$t('Formularios.CantidadDigital')" :readonly="producto.ilimitado" type="number"/>
                                      </v-col>
                                      <v-col cols="4">
                                        <v-switch solo v-model="producto.ilimitado" :label="$t('Formularios.Ilimitado')" color="error" />
                                      </v-col>
                                      <v-col cols="12">
                                        <v-file-input :rules="requerido" solo v-model="archivoDigital" :label="$t('Formularios.ArchivoDigital')" :hint="$t('Formularios.ArchivoDigital')" persistent-hint/>
                                      </v-col>
                                        </v-row>
                                    <v-divider />
                                  </v-col>
                                  <v-row v-if="producto.fisico && !producto.exponer" class="mx-1">
                                    <v-col cols="12">
                                      <h3>{{$t('Formularios.MedidasProducto')}}</h3>
                                    </v-col>
                                    <v-col cols="12" xs="12" md="3">
                                      <v-text-field solo v-model="producto.dimensiones.largo" :label="$t('Formularios.Largo')" :hint="$t('Formularios.Largo')" persistent-hint type="number" onwheel="return false;"/>
                                    </v-col>
                                    <v-col cols="12" xs="12" md="3">
                                      <v-text-field solo v-model="producto.dimensiones.ancho" :label="$t('Formularios.Ancho')" :hint="$t('Formularios.Ancho')" persistent-hint type="number" onwheel="return false;"/>
                                    </v-col>
                                    <v-col cols="12" xs="12" md="3">
                                      <v-text-field solo v-model="producto.dimensiones.alto" :label="$t('Formularios.Alto')" :hint="$t('Formularios.Alto')" persistent-hint type="number" onwheel="return false;"/>
                                    </v-col>
                                    <v-col cols="12" xs="12" md="3">
                                      <v-text-field solo v-model="producto.dimensiones.peso" :label="$t('Formularios.Peso')" :hint="$t('Formularios.Peso')" persistent-hint type="number" onwheel="return false;"/>
                                    </v-col>
                                    <v-col cols="12">
                                      <h3>{{$t('Formularios.MedidasEmpacado')}}</h3>
                                    </v-col>
                                    <template v-if="producto.dimensiones">
                                      <v-col cols="12" xs="12" md="3">
                                          <v-text-field solo v-model="producto.dimensiones.largoEmpacado" :label="$t('Formularios.Largo')" :hint="$t('Formularios.Largo')" persistent-hint type="number" onwheel="return false;"/>
                                      </v-col>
                                      <v-col cols="12" xs="12" md="3">
                                        <v-text-field solo v-model="producto.dimensiones.anchoEmpacado" :label="$t('Formularios.Ancho')" :hint="$t('Formularios.Ancho')" persistent-hint type="number" onwheel="return false;"/>
                                      </v-col>
                                      <v-col cols="12" xs="12" md="3">
                                        <v-text-field solo v-model="producto.dimensiones.altoEmpacado" :label="$t('Formularios.Alto')" :hint="$t('Formularios.Alto')" persistent-hint type="number" onwheel="return false;"/>
                                      </v-col>
                                      <v-col cols="12" xs="12" md="3">
                                        <v-text-field solo v-model="producto.dimensiones.pesoEmpacado" :label="$t('Formularios.Peso')" :hint="$t('Formularios.Peso')" persistent-hint type="number" onwheel="return false;"/>
                                      </v-col>
                                    </template>
                                    <v-col cols="12" sm="12" md="6" class="pb-0" v-if="getUsuario.categoria === 'artista'">
                                      <v-switch solo v-model="producto.enrollado" :label="$t('Formularios.IncluirEnrollado')" @change="cambioIncluirEnrollado" color="error" style="word-break:break-word;" class="mt-0"/>
                                    </v-col>
                                    <v-row class="mx-1 py-0" v-if="producto.enrollado && getUsuario.categoria === 'artista'">
                                      <v-col cols="12" class="pt-0">
                                        <h3>{{$t('Formularios.MedidasEmpacadoEnrollado')}}</h3>
                                      </v-col>
                                      <template v-if="producto.dimensionesEnrollado">
                                        <v-col cols="12" xs="12" md="3">
                                            <v-text-field solo v-model="producto.dimensionesEnrollado.largoEmpacado" :label="$t('Formularios.Largo')" :hint="$t('Formularios.Largo')" persistent-hint type="number"/>
                                        </v-col>
                                        <v-col cols="12" xs="12" md="3">
                                          <v-text-field solo v-model="producto.dimensionesEnrollado.anchoEmpacado" :label="$t('Formularios.Ancho')" :hint="$t('Formularios.Ancho')" persistent-hint type="number"/>
                                        </v-col>
                                        <v-col cols="12" xs="12" md="3">
                                          <v-text-field solo v-model="producto.dimensionesEnrollado.altoEmpacado" :label="$t('Formularios.Alto')" :hint="$t('Formularios.Alto')" persistent-hint type="number"/>
                                        </v-col>
                                        <v-col cols="12" xs="12" md="3">
                                          <v-text-field solo v-model="producto.dimensionesEnrollado.pesoEmpacado" :label="$t('Formularios.Peso')" :hint="$t('Formularios.Peso')" persistent-hint type="number"/>
                                        </v-col>
                                      </template>
                                    </v-row>
                                  </v-row>
                                  <v-col cols="12" align="center" v-if="mensaje != null">
                                    <span>{{mensaje}}</span>
                                  </v-col>

                                  <v-col cols="12">
                                    <div style="display:flex">
                                      <v-checkbox v-model="producto.aceptarCreatC"></v-checkbox>
                                      <span style="margin-top: 14px">
                                        {{$t('Formularios.AceptarCreativeC')}}
                                        <a style="color: rgb(47, 136, 136) !important; padding-left:4px; font-size: 18px;"
                                        href="/creativecommons" target="_blank">
                                        {{$t('Formularios.Aqui')}}</a>
                                      </span>
                                    </div>
                                  </v-col>
                                  <!-- <span>{{$t('Formularios.MasInformacion')}}</span> -->

                                  <v-col xs="12" sm="4">
                                      <v-btn outlined style="border: 2px solid" @click="cerrar()" block>{{ $t('Formularios.Cerrar') }}</v-btn>
                                  </v-col>
                                  <v-col xs="12" sm="8">
                                      <v-btn v-if="getTipoMontaje === 'editar'" color="primary" @click="actualizar()" :disabled="!valido" block :loading="getCargandoAccion">{{$t('Formularios.Actualizar')}}</v-btn>
                                      <v-btn v-else color="primary" @click="publicar()" :disabled="!valido" block :loading="getCargandoAccion">{{ $t('Formularios.Publicar') }}</v-btn>
                                  </v-col>
                              </v-row>
                          </v-container>
                        </v-card-title>
                    </v-card>
                  </v-form>
                </v-dialog>
                <v-dialog v-model="dialogColor" max-width="500px" persistent>
                  <v-card>
                    <v-card-title>
                      <v-row>
                        <v-col cols="12" align="center" class="my-5">
                          <h2 v-if="variante === 'nuevo'" class="vietnam black--text display-2">{{$t('Oficina.NuevoColor')}}</h2>
                          <h2 v-if="variante === 'editar'" class="vietnam black--text display-2">{{$t('Oficina.ActualizarColor')}}</h2>
                        </v-col>
                        <v-col cols="2">
                          <v-avatar :color="preColor.hex" size="50" />
                        </v-col>
                        <v-col cols="10">
                          <v-autocomplete solo :items="colores" v-model="preTituloColor" item-text="titulo" item-value="id" :label="$t('Formularios.Color')" :hint="$t('Formularios.Color')" rquired/>
                        </v-col>
                        <!-- <v-col cols="10">
                          <v-text-field solo v-model="preTituloColor" :label="$t('Oficina.Color')" :hint="$t('Oficina.Color')"/>
                        </v-col> -->
                        <v-col cols="12" align="center">
                          <Chrome v-model="preColor"/>
                        </v-col>
                        <v-col cols="12" align="center">
                          <v-btn class="ma-3" large outlined style="border: 2px solid" @click="dialogColor = false">{{$t('Formularios.Cerrar')}}</v-btn>
                          <v-btn class="ma-3" large v-if="variante === 'nuevo'" color="black white--text" @click="color({tipo: 'publicar'})">{{$t('Oficina.NuevoColor')}}</v-btn>
                          <v-btn class="ma-3" large v-if="variante === 'editar'" color="black white--text" @click="color({tipo: 'actualizar'})">{{$t('Oficina.ActualizarColor')}}</v-btn>
                        </v-col>
                      </v-row>
                    </v-card-title>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogTalla" max-width="500px" persistent>
                  <v-card>
                    <v-card-title>
                      <v-row>
                        <v-col cols="12" align="center" class="my-5">
                          <h2 v-if="variante === 'nuevo'" class="vietnam black--text display-2">{{$t('Oficina.NuevaTalla')}}</h2>
                          <h2 v-if="variante === 'editar'" class="vietnam black--text display-2">{{$t('Oficina.ActualizarTalla')}}</h2>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field solo v-model="preTalla" :label="$t('Oficina.Talla')" :hint="$t('Oficina.Talla')" />
                        </v-col>
                        <v-col cols="12" align="center">
                          <v-btn class="ma-3" large outlined style="border: 2px solid" @click="dialogTalla = false">{{$t('Formularios.Cerrar')}}</v-btn>
                          <v-btn class="ma-3" large v-if="variante === 'nuevo'" color="primary" @click="talla({tipo: 'publicar'})">{{$t('Oficina.NuevaTalla')}}</v-btn>
                          <v-btn class="ma-3" large v-if="variante === 'editar'" color="primary" @click="talla({tipo: 'actualizar'})">{{$t('Oficina.ActualizarTalla')}}</v-btn>
                        </v-col>
                      </v-row>
                    </v-card-title>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogInventario" max-width="500px" persistent>
                  <v-card>
                    <v-card-title>
                      <v-row>
                        <v-col cols="12" align="center" class="mb-5">
                          <h2 v-if="variante === 'nuevo'">{{$t('Oficina.NuevaVariacion')}}</h2>
                          <h2 v-if="variante === 'editar'">{{$t('Oficina.ActualizarVariacion')}}</h2>
                        </v-col>
                        <v-col cols="12" v-if="producto.talla">
                          <v-select solo v-model="preTalla" :items="producto.tallas" :label="$t('Oficina.Talla')" :hint="$t('Oficina.Talla')" />
                        </v-col>
                        <v-col cols="12" v-if="producto.color">
                          <v-select solo v-model="preColor" :items="producto.colores" item-text="tituloColor" return-object :label="$t('Oficina.Color')" :hint="$t('Oficina.Color')" />
                        </v-col>
                        <v-col cols="12">
                          <v-text-field solo v-model="preCantidad" :label="$t('Oficina.Cantidad')" :hint="$t('Oficina.Cantidad')" />
                        </v-col>
                        <v-col cols="12" align="center">
                          <v-btn class="ma-3" large outlined style="border: 2px solid" @click="dialogInventario = false">{{$t('Formularios.Cerrar')}}</v-btn>
                          <v-btn class="ma-3" large v-if="variante === 'nuevo'" color="primary white--text" @click="inventario({tipo: 'publicar'})">{{$t('Oficina.NuevaVariacion')}}</v-btn>
                          <v-btn class="ma-3" large v-if="variante === 'editar'" color="primary white--text" @click="inventario({tipo: 'actualizar'})">{{$t('Oficina.ActualizarVariacion')}}</v-btn>
                        </v-col>
                      </v-row>
                    </v-card-title>
                  </v-card>
                </v-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import * as faker from 'faker'
import firebase from '@/plugins/firebase'
import axios from 'axios'
import { Chrome } from 'vue-color'
/* import { relativeTimeRounding } from 'moment' */
export default {
  name: 'DialogProducto',
  props: ['productoEditar'],
  components: {
    Chrome
  },
  watch: {
    getTipoMontaje: function (newVal, oldVal) {
      if (newVal === 'editar') {
        this.producto = this.productoEditar
      }
      if (newVal === 'nuevo') {
        this.producto = {
          // INFO
          uid: faker.random.alphaNumeric(8),
          video: null,
          plataforma: null,
          aprobado: false,
          revision: false,
          exponer: false,
          titulo: null,
          descripcion: null,
          descripcionEn: null,
          categoria: this.getUsuario.categoria,
          subcategoria: null,
          meGusta: 0,
          materiales: null,
          materialesEn: null,
          cuidados: null,
          cuidadosEn: null,
          tecnica: null,
          tecnicaEn: null,
          estilo: null,
          orientacion: null,
          etiquetas: null,
          iva: false,
          ivaDigital: false,
          artista: {
            uid: this.getUsuario.uid,
            nombre: this.getUsuario.nombre,
            nombreDeUsuario: this.getUsuario.nombreDeUsuario,
            pais: this.getPaises[this.getUsuario.pais - 1].name,
            codigo: this.getPaises[this.getUsuario.pais - 1].iso2,
            email: this.getUsuario.email,
            codigoPostal: this.getUsuario.codigoPostal
          },
          dimensiones: {
            alto: null,
            largo: null,
            ancho: null,
            peso: null,
            altoEmpacado: null,
            largoEmpacado: null,
            anchoEmpacado: null,
            pesoEmpacado: null
          },
          enrollado: false,
          dimensionesEnrollado: {
            altoEmpacado: null,
            largoEmpacado: null,
            anchoEmpacado: null,
            pesoEmpacado: null
          },
          // Creative Commons
          aceptarCreatC: false,
          // IMAGENES
          imagenPrincipal: null,
          imagenes: [],
          // FISICO
          fisico: true,
          fisicosVendidos: 0,
          precioFisico: null,
          precioFisicoUSD: null,
          descuentoFisico: 0,
          cantidadFisico: 0,
          // ENVIOS
          envioIncluido: false,
          precioCOL: false,
          precioUSD: false,
          costeEnvio: null,
          // DIGITAL
          digital: false,
          digitalesVendidos: 0,
          descuentoDigital: 0,
          ilimitado: false,
          cantidadDigital: 0,
          precioDigital: null,
          precioDigitalUSD: null,
          // PRECIO
          precioPago: null,
          precioPagoDig: null,
          // TALLA
          talla: false,
          tallas: [],
          tablaDeTallas: null,
          // COLOR
          color: false,
          colores: [],
          // INVENTARIO
          inventario: []
        }
      }
    },
    getDialogMontaje: function (newVal, oldVal) {
      this.dialog = newVal
    },

    getIdioma: function (n, o) {
      this.idioma = n
      if (n) {
        this.marcasDeAgua = [
          { titulo: this.$i18n.t('Formularios.AbajoIzquierda'), id: 'abajoIzquierda' },
          { titulo: this.$i18n.t('Formularios.AbajoDerecha'), id: 'abajoDerecha' },
          { titulo: this.$i18n.t('Formularios.Centro'), id: 'centro' },
          { titulo: this.$i18n.t('Formularios.ArribaIzquierda'), id: 'arribaIzquierda' },
          { titulo: this.$i18n.t('Formularios.ArribaDerecha'), id: 'arribaDerecha' }
        ]
        this.headerInventario = [
          { text: this.$i18n.t('Oficina.Color'), value: 'color', align: 'center' },
          { text: this.$i18n.t('Oficina.TituloColor'), value: 'tituloColor', align: 'center' },
          { text: this.$i18n.t('Oficina.Talla'), value: 'talla', align: 'center' },
          { text: this.$i18n.t('Oficina.Cantidad'), value: 'cantidad', align: 'center' },
          { text: this.$i18n.t('Oficina.Acciones'), value: 'acciones', align: 'center', sortable: false }
        ]
        this.headerColores = [
          { text: this.$i18n.t('Oficina.Color'), value: 'color', align: 'center' },
          { text: this.$i18n.t('Oficina.TituloColor'), value: 'tituloColor', align: 'center' },
          { text: this.$i18n.t('Oficina.Acciones'), value: 'acciones', align: 'center', sortable: false }
        ]
        this.headerTallas = [
          { text: this.$i18n.t('Oficina.Talla'), value: 'talla', align: 'center' },
          { text: this.$i18n.t('Oficina.Acciones'), value: 'acciones', align: 'center', sortable: false }
        ]
        let subcat = []
        let estilo = []
        let orient = []
        let color = []
        for (let i = 0; i < this.subcategorias.length; i++) {
          subcat.push({
            titulo: this.$i18n.t(`Categoria.${this.subcategorias[i].id}`),
            id: this.subcategorias[i].id
          })
          if (i === (this.subcategorias.length - 1)) {
            this.subcategorias = subcat
          }
        }
        for (let i = 0; i < this.estilos.length; i++) {
          estilo.push({
            titulo: this.$i18n.t(`Categoria.${this.estilos[i].id}`),
            id: this.estilos[i].id
          })
          if (i === (this.estilos.length - 1)) {
            this.estilos = estilo
          }
        }
        for (let i = 0; i < this.orientaciones.length; i++) {
          orient.push({
            titulo: this.$i18n.t(`Categoria.${this.orientaciones[i].id}`),
            id: this.orientaciones[i].id
          })
          if (i === (this.orientaciones.length - 1)) {
            this.orientaciones = orient
          }
        }
        for (let i = 0; i < this.colores.length; i++) {
          color.push({
            titulo: this.$i18n.t(`Categoria.${this.colores[i].id}`),
            id: this.colores[i].id
          })
          if (i === (this.colores.length - 1)) {
            this.colores = color
          }
        }
      }
    }
  },
  mounted () {
    firebase.firestore().collection('utilidades').doc('categorias').get().then(info => {
      if (this.getUsuario.categoria === 'artista') {
        for (let i = 0; i < info.data().artistas.length; i++) {
          this.subcategorias.push({
            titulo: this.$i18n.t('Categoria.' + info.data().artistas[i]),
            id: info.data().artistas[i]
          })
          // this.subcategorias.push(info.data().artistas[i])
        }
        for (let i = 0; i < info.data().estilosArtistas.length; i++) {
          this.estilos.push({
            titulo: this.$i18n.t('Categoria.' + info.data().estilosArtistas[i]),
            id: info.data().estilosArtistas[i]
          })
          // this.estilos.push(info.data().estilosArtistas[i])
        }
        for (let i = 0; i < info.data().orientacion.length; i++) {
          this.orientaciones.push({
            titulo: this.$i18n.t('Categoria.' + info.data().orientacion[i]),
            id: info.data().orientacion[i]
          })
          // this.orientaciones.push(info.data().orientacion[i])
        }
      } else {
        for (let i = 0; i < info.data().disenadores.length; i++) {
          this.subcategorias.push({
            titulo: this.$i18n.t('Categoria.' + info.data().disenadores[i]),
            id: info.data().disenadores[i]
          })
          // this.subcategorias.push(info.data().disenadores[i])
        }
      }
      for (let i = 0; i < info.data().colores.length; i++) {
        this.colores.push({
          titulo: this.$i18n.t('Categoria.' + info.data().colores[i]),
          id: info.data().colores[i]
        })
        // this.colores.push(info.data().colores[i])
      }
    })
  },
  data () {
    return {
      mensaje: null,
      archivoDigital: null,
      plataformas: ['Youtube', 'Vimeo'],
      dialog: false,
      valido: false,
      producto: null,
      preImagenPrincipal: null,
      preImagenes: [],
      preTablaDeTallas: null,
      requerido: [v => !!v || this.$i18n.t('Formularios.CampoRequerido')],
      // eslint-disable-next-line
      requeridoNumber: [v => v != 0 || this.$i18n.t('Formularios.CampoRequerido')],
      subcategorias: [],
      estilos: [],
      orientaciones: [],
      colores: [],
      headerInventario: [
        { text: this.$i18n.t('Oficina.Color'), value: 'color', align: 'center' },
        { text: this.$i18n.t('Oficina.TituloColor'), value: 'tituloColor', align: 'center' },
        { text: this.$i18n.t('Oficina.Talla'), value: 'talla', align: 'center' },
        { text: this.$i18n.t('Oficina.Cantidad'), value: 'cantidad', align: 'center' },
        { text: this.$i18n.t('Oficina.Acciones'), value: 'acciones', align: 'center', sortable: false }
      ],
      headerColores: [
        { text: this.$i18n.t('Oficina.Color'), value: 'color', align: 'center' },
        { text: this.$i18n.t('Oficina.TituloColor'), value: 'tituloColor', align: 'center' },
        { text: this.$i18n.t('Oficina.Acciones'), value: 'acciones', align: 'center', sortable: false }
      ],
      headerTallas: [
        { text: this.$i18n.t('Oficina.Talla'), value: 'talla', align: 'center' },
        { text: this.$i18n.t('Oficina.Acciones'), value: 'acciones', align: 'center', sortable: false }
      ],
      preTituloColor: null,
      preColor: {
        a: 1,
        hex: '#FDFF71',
        hex8: '#FDFF71FF',
        hsl: {
          a: 1,
          h: 60.88235294117649,
          l: 0.7224999999999999,
          s: 1
        },
        hsv: {
          a: 1,
          h: 60.88235294117649,
          s: 0.555,
          v: 1
        },
        oldHue: 60.88235294117649,
        rgba: {
          a: 1,
          b: 113,
          g: 255,
          r: 253
        },
        source: 'hsva'
      },
      preTalla: null,
      preCantidad: null,
      checkCantidad: null,
      preUid: null,
      dialogTalla: false,
      dialogColor: false,
      dialogInventario: false,
      indexEditado: null,
      variante: 'nuevo',
      marca: 'abajoIzquierda',
      marcasDeAgua: [
        { titulo: this.$i18n.t('Formularios.AbajoIzquierda'), id: 'abajoIzquierda' },
        { titulo: this.$i18n.t('Formularios.AbajoDerecha'), id: 'abajoDerecha' },
        { titulo: this.$i18n.t('Formularios.Centro'), id: 'centro' },
        { titulo: this.$i18n.t('Formularios.ArribaIzquierda'), id: 'arribaIzquierda' },
        { titulo: this.$i18n.t('Formularios.ArribaDerecha'), id: 'arribaDerecha' }
      ],
      checkEnvio: false,
      checkCOL: true,
      checkUSD: false,
      idioma: null
    }
  },
  computed: {
    ...mapGetters(['getUsuario', 'getDolar', 'getComision', 'getCargandoAccion', 'getDialogMontaje', 'getTipoMontaje', 'getPaises', 'getIdioma']),
    comisionTrArtistFisico: function () {
      return Math.round(this.precioSinIVAFisico * 0.35)
    },
    comisionTrArtistFisicoUSD: function () {
      return Math.round(this.precioSinIVAFisicoUSD * 0.35)
    },
    ivaNetoFisico: function () {
      if (this.producto.iva) {
        return Math.round(this.producto.precioFisico * 0.19)
      } else {
        return 0
      }
    },
    ivaNetoFisicoUSD: function () {
      if (this.producto.iva) {
        return Math.round(this.producto.precioFisicoUSD * 0.19)
      } else {
        return 0
      }
    },
    precioSinIVAFisico: function () {
      return Math.round(Number(this.producto.precioFisico) / 0.65)
    },
    precioSinIVAFisicoUSD: function () {
      return Math.round(Number(this.producto.precioFisicoUSD) / 0.65)
    },
    vendedorRecibiraFisico: function () {
      return Math.round(Number(this.producto.precioFisico) + Number(this.ivaNetoFisico))
    },
    vendedorRecibiraFisicoUSD: function () {
      return Math.round(Number(this.producto.precioFisicoUSD) + Number(this.ivaNetoFisicoUSD))
    },
    precioFinalFisicoCOP: function () {
    // return Math.round(Number(this.precioSinIVAFisico) + Number(this.ivaNetoFisico))
      return Math.ceil((Number(this.precioSinIVAFisico) + Number(this.ivaNetoFisico)) / 100) * 100
    // parseInt(307692 / 100) * 100
    },
    precioFinalFisicoUSD: function () {
      return Math.ceil((Number(this.precioSinIVAFisicoUSD) + Number(this.ivaNetoFisicoUSD)))
    },
    // precioFinalFisicoUSD: function () {
    //   return Math.round((Number(this.producto.precioFisico) + ((Number(this.producto.precioFisico) * this.getComision) / 100)) / this.getDolar)
    // },
    comisionTrArtistDigital: function () {
      return Math.round(this.precioSinIVADigital * 0.35)
    },
    comisionTrArtistDigitalUSD: function () {
      return Math.round(this.precioSinIVADigitalUSD * 0.35)
    },
    ivaNetoDigital: function () {
      if (this.producto.ivaDigital) {
        return Math.round(this.producto.precioDigital * 0.19)
      } else {
        return 0
      }
    },
    ivaNetoDigitalUSD: function () {
      if (this.producto.ivaDigital) {
        return Math.round(this.producto.precioDigitalUSD * 0.19)
      } else {
        return 0
      }
    },
    precioSinIVADigital: function () {
      return Math.round(Number(this.producto.precioDigital) / 0.65)
    },
    precioSinIVADigitalUSD: function () {
      return Math.round(Number(this.producto.precioDigitalUSD) / 0.65)
    },
    vendedorRecibiraDigital: function () {
      return Math.round(Number(this.producto.precioDigital) + Number(this.ivaNetoDigital))
    },
    vendedorRecibiraDigitalUSD: function () {
      return Math.round(Number(this.producto.precioDigitalUSD) + Number(this.ivaNetoDigitalUSD))
    },
    precioFinalDigitalCOP: function () {
      return Math.ceil((Number(this.precioSinIVADigital) + Number(this.ivaNetoDigital)) / 100) * 100
    },
    precioFinalDigitalUSD: function () {
      return Math.ceil((Number(this.precioSinIVADigitalUSD) + Number(this.ivaNetoDigitalUSD)))
    },
    // precioFinalDigitalUSD: function () {
    //   return Math.round((Number(this.producto.precioDigital) + ((Number(this.producto.precioDigital) * this.getComision) / 100)) / this.getDolar)
    // },
    check_div_style () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'display: block; width: 100%; justify-content: space-between;'
        case 'sm': return 'display: block; width: 100%; justify-content: space-between;'
        case 'md': return 'display: flex; width: 100%; justify-content: space-between;'
        case 'lg': return 'display: flex; width: 100%; justify-content: space-between;'
        case 'xl': return 'display: flex; width: 100%; justify-content: space-between;'
        default: return 'display: flex; width: 100%; justify-content: space-between;'
      }
    },
    check_div_style_ct () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'display: block; width: 100%; justify-content: space-around;'
        case 'sm': return 'display: block; width: 100%; justify-content: space-around;'
        case 'md': return 'display: flex; width: 100%; justify-content: space-around;'
        case 'lg': return 'display: flex; width: 100%; justify-content: space-around;'
        case 'xl': return 'display: flex; width: 100%; justify-content: space-around;'
        default: return 'display: flex; width: 100%; justify-content: space-around;'
      }
    }
  },
  methods: {
    ...mapMutations(['setAlerta', 'setTextoAlerta', 'setCargandoAccion', 'setDialogMontaje', 'setTipoMontaje']),
    /* ...mapActions(['addDialog']), */
    async cerrar () {
      this.setDialogMontaje(false)
      this.setTipoMontaje('ninguno')
      this.$refs.form.resetValidation()
      // this.$emit('onResult')
      // this.producto.descripcion = ''
    },
    async actualizar () {
      this.setCargandoAccion(true)
      this.producto.aprobado = false
      this.producto.revision = false
      // console.log('hola', this.producto.revision)

      if (this.getUsuario.pais === 48 && this.producto.precioCOL) {
        this.producto.precioPago = this.precioFinalFisicoCOP
        this.producto.precioPagoDig = this.precioFinalDigitalCOP
      } else {
        this.producto.precioPago = this.precioFinalFisicoUSD
        this.producto.precioPagoDig = this.precioFinalDigitalCOP
      }

      if (this.archivoDigital) {
        var archivo = await firebase.storage().ref().child('/productos/' + this.producto.uid + '/compra/' + this.archivoDigital.name).put(this.archivoDigital)
        var url = await archivo.ref.getDownloadURL()
        this.producto.archivoDigital = url
      }
      if (this.preTablaDeTallas) {
        var tabla = await firebase.storage().ref().child('/productos/' + this.producto.uid + '/' + this.preTablaDeTallas.name).put(this.preTablaDeTallas)
        var urlTabla = await tabla.ref.getDownloadURL()
        this.producto.tablaDeTallas = urlTabla
        if (url && urlTabla) {
          this.segundoPaso()
        }
      }
      if (this.preImagenPrincipal) {
        this.getBase64(this.preImagenPrincipal).then(imagen => {
          this.marcaDeAgua(imagen).then(imagenMarcada => {
            this.subir({ name: this.preImagenPrincipal.name, data: imagenMarcada }).then(url => {
              this.producto.imagenPrincipal = url
            })
          })
        })
      }
      if (this.preImagenes) {
        for (let i = 0; i < this.preImagenes.length; i++) {
          this.getBase64(this.preImagenes[i]).then(imagen => {
            this.marcaDeAgua(imagen).then(imagenMarcada => {
              this.subir({ name: this.preImagenes[i].name, data: imagenMarcada }).then(url => {
                this.producto.imagenes.push(url)
              })
            })
          })
        }
      }

      firebase.firestore().collection('productos').doc(this.producto.uid).update(this.producto).then(() => {
        this.setAlerta()
        this.setTextoAlerta('Alerta.ProductoEnAprobacion')
        // this.addDialog('Alerta.ProductoEnAprobacion')
        this.setCargandoAccion(false)
        this.setDialogMontaje(false)
        this.setTipoMontaje('ninguno')
        this.$emit('onResult')
      })
    },
    async publicar () {
      this.setCargandoAccion(true)
      if (this.getUsuario.pais === 48 && this.producto.precioCOL) {
        this.producto.precioPago = this.precioFinalFisicoCOP
        this.producto.precioPagoDig = this.precioFinalDigitalCOP
      } else {
        this.producto.precioPago = this.precioFinalFisicoUSD
        this.producto.precioPagoDig = this.precioFinalDigitalUSD
      }

      if (this.producto.video) {
        var videoId = this.producto.video.split('v=')[1]
        var ampersandPosition = videoId.indexOf('&')
        if (ampersandPosition !== -1) {
          videoId = videoId.substring(0, ampersandPosition)
        }
        this.producto.video = videoId
      }
      if (this.producto.digital) {
        this.mensaje = this.$i18n.t('Formularios.SubiendoArchivoDigital')
        // this.mensaje = 'Subiendo Archivo Digital'
        var archivo = await firebase.storage().ref().child('/productos/' + this.producto.uid + '/compra/' + this.archivoDigital.name).put(this.archivoDigital)
        var url = await archivo.ref.getDownloadURL()
        this.producto.archivoDigital = url
        if (url) {
          this.segundoPaso()
        }
      } else {
        if (this.preTablaDeTallas) {
          this.mensaje = this.$i18n.t('Formularios.SubiendoTablaTallas')
          // this.mensaje = 'Subiendo Tabla de Tallas'
          var tabla2 = await firebase.storage().ref().child('/productos/' + this.producto.uid + '/' + this.preTablaDeTallas.name).put(this.preTablaDeTallas)
          var urlTabla2 = await tabla2.ref.getDownloadURL()
          this.producto.tablaDeTallas = urlTabla2
          if (urlTabla2) {
            this.segundoPaso()
          }
        } else {
          this.segundoPaso()
        }
      }
    },
    async segundoPaso () {
      this.mensaje = this.$i18n.t('Formularios.ProcesandoImagenPrincipal')
      // this.mensaje = 'Procesando Imagen Principal'
      this.getBase64(this.preImagenPrincipal).then(imagen => {
        this.marcaDeAgua(imagen).then(imagenMarcada => {
          this.subir({ name: this.preImagenPrincipal.name, data: imagenMarcada }).then(url => {
            this.producto.imagenPrincipal = url
            if (url) {
              this.tercerPaso()
            }
          })
        })
      })
    },
    async tercerPaso () {
      if (this.preImagenes[0]) {
        this.mensaje = this.$i18n.t('Formularios.SubiendoImagenesSecundarias')
        // this.mensaje = 'Subiendo Imágenes Secundarias'
        var cont = this.preImagenes.length
        for (let i = 0; i < this.preImagenes.length; i++) {
          this.getBase64(this.preImagenes[i]).then(imagen => {
            this.marcaDeAgua(imagen).then(imagenMarcada => {
              this.subir({ name: this.preImagenes[i].name, data: imagenMarcada }).then(url => {
                this.producto.imagenes.push(url)
                cont = cont - 1
                if (cont === 0) {
                  this.finalizar()
                }
              })
            })
          })
        }
      } else {
        this.finalizar()
      }
    },
    getBase64 (file) {
      const reader = new FileReader()
      return new Promise(resolve => {
        reader.onload = ev => {
          resolve(ev.target.result)
        }
        reader.readAsDataURL(file)
      })
    },
    marcaDeAgua (imagen) {
      return new Promise(resolve => {
        axios({
          method: 'post',
          url: '/subir',
          crossDomain: true,
          data: {
            image: imagen,
            tipo: this.marca
          }
        }).then(respuesta => {
          fetch(respuesta.data.secure_url).then(res => res.blob()).then(blob => {
            axios({
              method: 'post',
              url: '/eliminar',
              crossDomain: true,
              data: {
                url: respuesta.data.public_id
              }
            })
            resolve(blob)
          })
        }).catch(error => {
          console.log(error)
        })
      })
    },
    async subir (info) {
      var upload = await firebase.storage().ref().child('/productos/' + this.producto.uid + '/' + info.name).put(info.data)
      var url = await upload.ref.getDownloadURL()
      return url
    },
    finalizar () {
      this.mensaje = this.$i18n.t('Formularios.SubiendoProducto')
      // this.mensaje = 'Subiendo Producto'
      firebase.firestore().collection('productos').doc(this.producto.uid).set(this.producto).then(() => {
        this.setAlerta()
        this.setTextoAlerta('Alerta.ProductoEnAprobacion')
        // this.addDialog('Alerta.ProductoEnAprobacion')
        this.setCargandoAccion(false)
        this.setDialogMontaje(false)
        this.setTipoMontaje('ninguno')
        this.$emit('onResult')
      })
    },
    eliminar (uid) {
      firebase.storage().ref('productos').child(uid).listAll().then(files => {
        for (let i = 0; i < files.items.length; i++) {
          firebase.storage().ref().child(files.items[i].fullPath).delete()
        }
      })
    },
    editarProducto (producto) {
      this.productoEditar = producto
      this.dialogEditar = true
    },
    color (info) {
      if (info.tipo === 'nuevo') {
        this.preTituloColor = ''
        this.preColor = {
          a: 1,
          hex: '#FDFF71',
          hex8: '#FDFF71FF',
          hsl: {
            a: 1,
            h: 60.88235294117649,
            l: 0.7224999999999999,
            s: 1
          },
          hsv: {
            a: 1,
            h: 60.88235294117649,
            s: 0.555,
            v: 1
          },
          oldHue: 60.88235294117649,
          rgba: {
            a: 1,
            b: 113,
            g: 255,
            r: 253
          },
          source: 'hsva'
        }
        this.variante = 'nuevo'
        this.dialogColor = true
      } else if (info.tipo === 'editar') {
        this.preColor = info.valor.color
        this.preTituloColor = info.valor.tituloColor
        for (let i = 0; i < this.producto.colores.length; i++) {
          if (info.valor.tituloColor === this.producto.colores[i].tituloColor) {
            this.indexEditado = i
            break
          }
        }
        this.variante = 'editar'
        this.dialogColor = true
      } else if (info.tipo === 'publicar') {
        if (this.producto.colores === undefined) {
          this.producto.colores = []
        }
        this.producto.colores.push({
          color: this.preColor,
          tituloColor: this.preTituloColor
        })
        this.dialogColor = false
      } else if (info.tipo === 'actualizar') {
        this.producto.colores[this.indexEditado].color = this.preColor
        this.producto.colores[this.indexEditado].tituloColor = this.preTituloColor
        this.dialogColor = false
      } else if (info.tipo === 'eliminar') {
        for (let i = 0; i < this.producto.colores.length; i++) {
          if (info.valor.tituloColor === this.producto.colores[i].tituloColor) {
            this.producto.colores.splice(i, 1)
            break
          }
        }
      }
    },
    talla (info) {
      if (info.tipo === 'nuevo') {
        this.preTalla = ''
        this.variante = 'nuevo'
        this.dialogTalla = true
      } else if (info.tipo === 'editar') {
        this.preTalla = info.valor
        for (let i = 0; i < this.producto.tallas.length; i++) {
          if (info.valor === this.producto.tallas[i]) {
            this.indexEditado = i
            break
          }
        }
        this.variante = 'editar'
        this.dialogTalla = true
      } else if (info.tipo === 'publicar') {
        if (this.producto.tallas === undefined) {
          this.producto.tallas = []
        }
        this.producto.tallas.push(this.preTalla)
        this.dialogTalla = false
      } else if (info.tipo === 'actualizar') {
        this.producto.tallas.splice(this.indexEditado, 1, this.preTalla)
        this.dialogTalla = false
      } else if (info.tipo === 'eliminar') {
        for (let i = 0; i < this.producto.tallas.length; i++) {
          if (info.valor === this.producto.tallas[i]) {
            this.producto.tallas.splice(i, 1)
            break
          }
        }
      }
    },
    inventario (info) {
      var unidad = {}
      if (info.tipo === 'nuevo') {
        this.preTalla = ''
        this.preColor = ''
        this.variante = 'nuevo'
        this.dialogInventario = true
      } else if (info.tipo === 'editar') {
        if (this.producto.talla) {
          this.preTalla = info.valor.talla
        }
        if (this.producto.color) {
          this.preColor = info.valor.color
        }
        this.preCantidad = info.valor.cantidad
        this.checkCantidad = info.valor.cantidad
        this.preUid = info.valor.uid
        for (let i = 0; i < this.producto.inventario.length; i++) {
          if (this.producto.inventario[i].uid === this.preUid) {
            this.indexEditado = i
            break
          }
        }
        this.variante = 'editar'
        this.dialogInventario = true
      } else if (info.tipo === 'publicar') {
        if (this.producto.talla && !this.preTalla) {
          this.setAlerta()
          this.setTextoAlerta('Formularios.EscogerTalla')
          // this.addDialog('Formularios.EscogerTalla')
          return
        }
        if (this.producto.color && !this.preColor) {
          this.setAlerta()
          this.setTextoAlerta('Formularios.EscogerColor')
          // this.addDialog('Formularios.EscogerColor')
          return
        }
        unidad.uid = faker.random.alphaNumeric(4)
        if (this.producto.talla) {
          unidad.talla = this.preTalla
        }
        if (this.producto.color) {
          unidad.color = this.preColor
        }
        unidad.cantidad = this.preCantidad
        if (this.producto.inventario === undefined) {
          this.producto.inventario = []
        }
        this.producto.inventario.push(unidad)
        this.producto.cantidadFisico = Number(this.producto.cantidadFisico) + Number(unidad.cantidad)
        this.dialogInventario = false
      } else if (info.tipo === 'actualizar') {
        if (this.producto.talla) {
          unidad.talla = this.preTalla
        }
        if (this.producto.color) {
          unidad.color = this.preColor
        }
        unidad.cantidad = this.preCantidad
        unidad.uid = this.preUid
        if (this.checkCantidad !== unidad.cantidad) {
          const diferencia = Math.abs(this.checkCantidad - unidad.cantidad)
          if (this.checkCantidad < unidad.cantidad) {
            this.producto.cantidadFisico = Number(this.producto.cantidadFisico) + Number(diferencia)
          } else {
            this.producto.cantidadFisico = Number(this.producto.cantidadFisico) - Number(diferencia)
          }
        }
        this.producto.inventario.splice(this.indexEditado, 1, unidad)
        this.dialogInventario = false
      } else if (info.tipo === 'eliminar') {
        for (let i = 0; i < this.producto.inventario.length; i++) {
          if (this.producto.inventario[i].uid === info.valor.uid) {
            this.producto.inventario.splice(i, 1)
            const cantidadFisico = Number(this.producto.cantidadFisico) ? Number(this.producto.cantidadFisico) : 0
            const cantidad = Number(info.valor.cantidad)
            if (cantidadFisico >= cantidad) {
              this.producto.cantidadFisico = cantidadFisico - cantidad
            } else {
              this.producto.cantidadFisico = 0
            }
            break
          }
        }
      }
    },
    eliminarImagen (index) {
      this.producto.imagenes.splice(index, 1)
    },
    limpiarInventario () {
      this.producto.inventario = []
      this.producto.cantidadFisico = 0
    },
    validarEnvioNacional () {
      let envio = this.producto.envioIncluido
      if (envio) this.producto.costeEnvio = ''
      this.checkEnvio = envio
    },
    precioCol () {
      let col = this.producto.precioCOL
      if (col) this.producto.precioUSD = false
      this.producto.precioFisico = 0
      this.producto.precioDigital = 0
      this.checkCOL = col
      this.checkUSD = false
      this.producto.iva = false
      this.producto.ivaDigital = false
    },
    precioUsd () {
      let usd = this.producto.precioUSD
      if (usd) this.producto.precioCOL = false
      this.producto.precioFisicoUSD = 0
      this.producto.precioDigitalUSD = 0
      this.checkUSD = usd
      this.checkCOL = false
      this.producto.iva = false
      this.producto.ivaDigital = false
    },
    cambioIncluirEnrollado () {
      if (!this.producto.enrollado) {
        this.producto.dimensionesEnrollado.altoEmpacado = null
        this.producto.dimensionesEnrollado.largoEmpacado = null
        this.producto.dimensionesEnrollado.anchoEmpacado = null
        this.producto.dimensionesEnrollado.pesoEmpacado = null
      }
    }
  }
}
</script>
